import React from 'react';
import { useTranslation } from "react-i18next";

const date = (props) => {
    const { i18n } = useTranslation();

    //let date = new Date('2013-08-03T02:00:00Z');
    let date = new Date(props.date);
    let year = date.getFullYear();
    let monthName = date.toLocaleString(i18n.language+'-ca', { month: 'long' });
    let dt = date.getDate();

    if (dt < 10) {
        dt = '0' + dt;
    }

    const formatAMPM = () => {
        let h = date.getHours();
        let m = date.getMinutes();
        if (m < 10) m = '0' + m;
        let ampm = h >= 12 ? 'pm' : 'am';
        h = h % 12;
        h = h ? h : 12; // the hour '0' should be '12'

        let strTime = h + ':' + m + ' ' + ampm;
        return strTime;
    }
    const format24h = () => {
        let h = date.getHours();
        let m = date.getMinutes();
        if (m < 10) m = '0' + m;
        let strTime = h+'h'+m;
        return strTime;
    }

    let time = "";
    if(props.withTime){
        time = ', '+formatAMPM();
        if(i18n.language == 'fr') time = ', '+format24h();
    }

    let dateFormat = '';
    let suffix = '';
    if(i18n.language == 'en'){
        suffix = 'th';
        if(dt === 1){ suffix = 'st'; }
        if(dt === 2){ suffix = 'nd'; }
        if(dt === 3){ suffix = 'rd'; }
        dateFormat = monthName + ' ' + dt + suffix + ' ' + year + ' ' + time;
    }
    if(i18n.language == 'fr'){
        if(dt === 1){ suffix = 'er'; }
        dateFormat = dt + suffix + ' ' + monthName + ' ' + year + ' ' + time;
    }

    return dateFormat;
};

export default date
